import * as React from "react"
import { cn } from "~/lib/utils"
import { Icon } from "~/react/ui/icon"
import { Separator } from "~/react/ui/separator"

export interface MetricsProps extends React.HTMLAttributes<HTMLDivElement> {}

const Metrics = React.forwardRef<HTMLDivElement, MetricsProps>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("metrics", className)} {...props} />
))
Metrics.displayName = "Metrics"

export interface MetricsItemProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: string
  iconColor?: string
  label: React.ReactNode
  value: React.ReactNode
  secondaryValue?: React.ReactNode
  wide?: boolean
}

const MetricsItem = React.forwardRef<HTMLDivElement, MetricsItemProps>(
  ({ className, icon, iconColor, label, value, secondaryValue, wide, children, ...props }, ref) => {
    return (
      <div ref={ref} className={cn("metrics-item", wide && "metrics-item--wide", className)} {...props}>
        <div className="metrics-item__top">
          {icon && (
            <Icon
              icon={icon}
              aria-hidden="true"
              size="sm"
              style={iconColor ? { color: iconColor } : { color: "var(--colors-grey-600)" }}
            />
          )}
          <span className="metrics-item__label">{label}</span>
        </div>
        <div className="metrics-item__bottom">
          <span className="metrics-item__value">{value}</span>
          {secondaryValue ? (
            <span className="metrics-item__secondary">
              (<>{secondaryValue}</>)
            </span>
          ) : null}
          {children}
        </div>
      </div>
    )
  },
)
MetricsItem.displayName = "MetricsItem"

export interface MetricsSeparatorProps extends React.ComponentPropsWithoutRef<typeof Separator> {}

function MetricsSeparator({ className, orientation = "vertical", full = true, ...props }: MetricsSeparatorProps) {
  return <Separator orientation={orientation} full={full} className={cn("metrics__separator", className)} {...props} />
}

export { Metrics, MetricsItem, MetricsSeparator }
